import { axiosInstance as axios } from 'Api';
import { handlingResponse } from 'Utility/globalMethods';
import { Config } from 'Constants/config_env';
/* eslint-disable global-require */
if (ISMOCK) {
	require('Mocks/home/home');
}

export async function getSales(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `summary/sales`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function getSalesCard(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `summary/sales/card`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function getCountries(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `config/get-countries`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

// Report Progress
export async function reportProgress(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'report/progress',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

// Download Promotion Report
export async function downloadXls(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'report/download',
			data: { ...params },
			responseType: 'arraybuffer',
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
// @generator api:method
